import { COLOR_VISION_FADED_OPACITY, COLOR_VISION_ACTIVE_OPACITY } from '../constants.js';

function getColorVisionStylesForActiveIndex({
  activeIndex,
  index,
  fadedOpacity = COLOR_VISION_FADED_OPACITY
}) {
  const activeOpacity = activeIndex === index ? COLOR_VISION_ACTIVE_OPACITY : fadedOpacity;
  return {
    opacity: activeIndex === -1 ? COLOR_VISION_ACTIVE_OPACITY : activeOpacity,
    transition: 'opacity 100ms ease'
  };
}

export { getColorVisionStylesForActiveIndex };
